module.exports = __webpack_public_path__ + "static/img/banner-en-2.0d1f8b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-en-2.jpg
// module id = HgMU
// module chunks = 1